import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';
import { GuestTagCombobox } from './GuestTagCombobox';

interface ControlledGuestTagComboboxProps<
  T extends FieldValues = FieldValues,
  Name extends FieldPath<T> = FieldPath<T>,
> {
  control: Control<T>;
  name: Name;
}

export const ControlledGuestTagCombobox = <
  T extends FieldValues = FieldValues,
  Name extends FieldPath<T> = FieldPath<T>,
>({
  control,
  name,
}: ControlledGuestTagComboboxProps<T, Name>) => {
  const {
    field: { onChange, value },
  } = useController({ control, name });

  return (
    <GuestTagCombobox defaultValue={value} onChange={onChange} name={name} />
  );
};
